import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
    dataReservationList: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 10,
    page: 1,
},
handleTriggerLoading: false,
otaCodeList: [],
pinpadDevicesList: []
};

const reservationListSlice = createSlice({
  name: "reservationList",
  initialState: initialState,
  reducers: {
    dataReservationListSuccess: (state, action) => {
      state.dataReservationList = {...state.dataReservationList, [action.payload?.key]: action.payload?.value }
    },
    dataReservationListFailed: (state, action) => {
      state.dataReservationList = {...state.dataReservationList, [action.payload?.key]: action.payload?.value }
    },
    handleTriggerLoadingSuccess: (state, action) => {
        state.handleTriggerLoading = true;
      },
    handleTriggerLoadingFailed: (state, action) => {
    state.handleTriggerLoading = false;
    },
    otaCodeListSuccess: (state, action) => {
        state.otaCodeList = action.payload;
      },
    otaCodeListFailed: (state, action) => {
    state.otaCodeList = [];
    },
    pinpadDevicesListSuccess: (state, action) => {
        state.pinpadDevicesList = action.payload;
    },
    pinpadDevicesListFailed: (state, action) => {
    state.pinpadDevicesList = [];
    },
    
  },
});

export const {
    dataReservationListSuccess,
    dataReservationListFailed,
    handleTriggerLoadingSuccess,
    handleTriggerLoadingFailed,
    otaCodeListSuccess,
    otaCodeListFailed,
    pinpadDevicesListSuccess,
    pinpadDevicesListFailed   
} = reservationListSlice.actions;

export default reservationListSlice.reducer;
